import { ETheme, EThemeBackground, EThemeColor } from "@/common/entity/Enum";
import { renderBackgroundColorByTheme } from "@/common/function/FunctionTheme";
import styled from "styled-components";

export const TimeRangeSliderWrapper = styled.div<{$theme?: string}>`
  background-color: ${props => props.$theme === ETheme.Dark ? EThemeBackground.Dark : EThemeBackground.Light};
  position: relative;
  border-left: 3px solid ${props => renderBackgroundColorByTheme(props.$theme)};
  margin-top: -1px;
  box-sizing: border-box;
  .button-left {
    position: absolute;
    left: -10px;
    top: 7px;
    transform: scale(1.3);
  }
  .button-right {
    position: absolute;
    right: -10px;
    top: 7px;
    transform: scale(1.3);
  }
  .timeline-zone {
    height: 28px;
    border-bottom: 2px solid #bbb;
    padding: 0 10px;
  }
  .timeline {
    position: relative;
  }
  .timeline-item {
    position: absolute;
  }
  .timeline-item-0 {
    left: 0;
  }
  .timeline-line-0 {
    left: 7.14%;
  }
  .timeline-item-1 {
    left: 14.29%;
  }
  .timeline-line-1 {
    left: 21.43%;
  }
  .timeline-item-2 {
    left: 28.58%;
  }
  .timeline-line-2 {
    left: 35.72%;
  }
  .timeline-item-3 {
    left: 42.87%;
  }
  .timeline-line-3 {
    left: 50.01%;
  }
  .timeline-item-4 {
    left: 57.16%;
  }
  .timeline-line-4 {
    left: 64.3%;
  }
  .timeline-item-5 {
    left: 71.45%;
  }
  .timeline-line-5 {
    left: 78.59%;
  }
  .timeline-item-6 {
    left: 85.74%;
  }
  .timeline-line-6 {
    left: 92.88%;
  }
  .timeline-item-7 {
    left: 100%;
  }
  .line {
    position: absolute;
    top: 22px;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 6px;
    background: #bbb;
  }
  .timeline-child {
    top: 5px;
    color: #000000;
    text-align: center;
    font: var(--textstyleoutlook-caption, 400 8px/12px "Segoe UI", sans-serif);
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    padding-bottom: 13px;
    font-size: 13px;
  }
  .timeline-child:after {
    content: "";
    height: 6px;
    width: 2px;
    position: absolute;
    background: #bbb;
    top: 17px;
    left: 50%;
    transform: translateX(-50%);
  }
  .date-time {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
    color: ${props => props.$theme === ETheme.Dark ? EThemeColor.ColorNeutralForeground4Dark : EThemeColor.ColorNeutralForeground4Light};
    text-align: right;
    font: var(--textstyleoutlook-caption, 400 8px/12px "Segoe UI", sans-serif);
    bottom: -15px;
    font-weight: 700;
  }
  .left-arrow:hover {
    cursor: pointer;
  }
  .right-arrow:hover {
    cursor: pointer;
  }
  .content-time-line {
    height: 20px;
  }
`;
